import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnRole, columnEmail, columnName,
} from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import UsersTableColumns from '../containers/UsersTableColumns';
import UsersTableRows from '../containers/UsersTableRows';

const UserArchivalTable = ({ isArchival, items }) => (
  <div className={`aridhia-user-${isArchival ? 'archival' : 'restoration'}-table`}>
    <TableWrapper sticky celled className="aridhia-users-table">
      <Table.Header fullWidth>
        <UsersTableColumns items={items} columns={[columnName, columnEmail, columnRole]} />
      </Table.Header>
      <Table.Body>
        <UsersTableRows items={items} columns={[columnName, columnEmail, columnRole]} />
      </Table.Body>
    </TableWrapper>
  </div>
);

export default UserArchivalTable;
